<template>
  <component
    :is="basicSetting.type"
    :default-value="basicSetting.defaultValue"
    :config.sync="basicConfigData[basicSetting.name]"
    :extraConfig="basicSetting.extraConfig"
    :title="basicSetting.desc"
    :suffix="basicSetting.suffix"
    :options="options"
  />
</template>
<script>
import propMapMixin from "./propMapMixin.js"
export default {
  name: "basic-item",
  mixins: [propMapMixin],
  inject: ["configData", "configs", "options"],
  props: {
    config: undefined
  },
  computed: {
    basicSetting() {
      if (typeof this.config === "string") {
        return this.configs.find(item => item.name === this.config) ?? {}
      } return this.configs.find(item => item.name === this.config?.name) ?? {}
    },
    basicConfigData() {
      return this.configData()
    }
  }
}
</script>
